var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageMiddleTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 96.033H336.025L268.801 6.4C265.6 2.133 260.801 0 256 0S246.4 2.133 243.199 6.4L175.975 96.033H64C28.75 96.033 0 124.781 0 160.029V448.006C0 483.252 28.75 512 64 512H448C483.25 512 512 483.252 512 448.006V160.029C512 124.781 483.25 96.033 448 96.033ZM496 448.006C496 474.471 474.467 496 448 496H64C37.533 496 16 474.471 16 448.006V160.029C16 133.564 37.533 112.033 64 112.033H183.975L255.963 16.004C255.967 16.004 255.98 16 256 16L328.025 112.033H448C474.467 112.033 496 133.564 496 160.029V448.006Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageMiddleTop);
export default __webpack_public_path__ + "static/media/message-middle-top.5826878f8094879afc0d6c0e791d66b8.svg";
export { ForwardRef as ReactComponent };